import {ChatTopic} from '../types/ChatModal.types';

export interface QuickSuggestion {
  label: string;
  query: string;
}

export const DEFAULT_CHAT_TOPIC: ChatTopic = 'orders';

export const QUICK_SUGGESTIONS: QuickSuggestion[] = [
  {
    label: 'Downline orders',
    query: 'How many orders did my downline have for last 3 months',
  },
  {
    label: 'Order trend',
    query: 'What are my order totals for the last quarter',
  },
  {
    label: 'Ranks',
    query: 'Show me all my rank information',
  },
  {
    label: 'Bonuses',
    query:
      'Top 5 coaches in my downline/org who earned the most in CSB+ bonuses in last year?',
  },
];

export const CHAT_HISTORY_STORAGE_KEY_PREFIX = 'connect-app-chat-history';
export const INTERIM_MESSAGE_DELAYS_MS = [4000, 12000, 24000];
export const LAST_SYNC_FETCH_COOLDOWN_MS = 65 * 60 * 1000;
